import type { StorageReference } from "firebase/storage";
import React, { useEffect, useState } from "react";
import { getCachedDownloadURL } from "../../utils/avatar.util";
import { emptyImage } from "../../utils/file.util";

type Props = {
    storageRef: StorageReference;
    alt?: string;
    className?: string | undefined;
    emptyString?: string;
};

const CachedAvatar = function CachedAvatar(props: Props) {
    const { storageRef, alt, className, emptyString } = props;
    const [avatar, setAvatar] = useState(emptyImage);

    useEffect(() => {
        const load = async () => {
            try {
                const avatarURL = await getCachedDownloadURL(storageRef);
                setAvatar(avatarURL || emptyImage);
            } catch {
                setAvatar(emptyImage);
            }
        };
        load();
    }, [storageRef]);

    if (avatar === emptyImage && emptyString) {
        return <div className={className}>{emptyString}</div>;
    }

    return <img className={className} src={avatar} alt={alt} />;
};

export default React.memo(CachedAvatar);
